import { LABELS } from '@/constants/common/message.constants'

import { type DcUserDcExEntity } from '../../aspida/@types'

/**
 * PMS権限 (拠点ユーザー、パートナーユーザーで共通)
 */
export type PmsRoleType = DcUserDcExEntity['pmsRoles'][number]

export const PMS_ROLE_TYPE = {
  /** 請求支払更新 */
  INVOICE_PAYMENT_UPDATE: 'INVOICE_PAYMENT_UPDATE',
  /** 日次承認 */
  DAILY_APPROVAL: 'DAILY_APPROVAL',
  /** 月次最終承認 */
  MONTHLY_FINAL_APPROVAL: 'MONTHLY_FINAL_APPROVAL',
  /** パートナー請求基本 */
  PARTNER_BILLING_BASE: 'PARTNER_BILLING_BASE'
} as const satisfies Record<PmsRoleType, PmsRoleType>

export const PMS_ROLE_TYPE_LABEL = {
  [PMS_ROLE_TYPE.INVOICE_PAYMENT_UPDATE]: LABELS.PMS_INVOICE_PAYMENT_UPDATE,
  [PMS_ROLE_TYPE.DAILY_APPROVAL]: LABELS.PMS_DAILY_APPROVAL,
  [PMS_ROLE_TYPE.MONTHLY_FINAL_APPROVAL]: LABELS.PMS_MONTHLY_FINAL_APPROVAL,
  [PMS_ROLE_TYPE.PARTNER_BILLING_BASE]: LABELS.PMS_PARTNER_BILLING_BASE
} as const satisfies Record<PmsRoleType, string>
